import { Component, OnInit, AfterViewInit } from '@angular/core';
import { AuthService } from 'angularx-social-login';
import { FacebookLoginProvider, GoogleLoginProvider, LinkedInLoginProvider } from 'angularx-social-login';
import { SocialUser } from 'angularx-social-login';
// declare $ for Jquery Initialization
declare var $: any;
@Component({
  selector: 'app-budget',
  templateUrl: './budget.component.html',
  styleUrls: ['./budget.component.css']
})
export class BudgetComponent implements OnInit, AfterViewInit {

  user: SocialUser;
  loggedIn: boolean;
   constructor(private authService: AuthService) { }

   ngOnInit() {
    this.authService.authState.subscribe((user) => {
      this.user = user;
      this.loggedIn = (user != null);
    });
  }

  signInWithGoogle(): void {
    this.authService.signIn(GoogleLoginProvider.PROVIDER_ID);
  }

  signInWithFB(): void {
    this.authService.signIn(FacebookLoginProvider.PROVIDER_ID);
  }
  signInWithLinkedIn(): void {
    this.authService.signIn(LinkedInLoginProvider.PROVIDER_ID);
  }

  signOut(): void {
    this.authService.signOut();
  }

   ngAfterViewInit () {
     $(document).ready(function() {
       $('.sidenav').sidenav();
     });
     $(document).ready(function() {
       $('select').formSelect();
     });
     $(document).ready(function() {
       $('.datepicker').datepicker();
     });
 }


}
